import { Form } from 'antd'
import dayjs from 'dayjs'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { useStocksServiceGetInternalInquiryEndpoint } from 'src/api/queries'
import { InternalInventoryDocumentState } from 'src/api/requests'
import { LoadingScreen, PageBreadcrumbs } from 'src/components'
import { useFileHandler } from 'src/hooks'
import { useLocales } from 'src/locales'

import { StockLocalAdminIssuanceApplicationsAcceptedDetails } from './StockLocalAdminIssuanceApplicationsAcceptedDetails'
import { StockLocalIssuanceApplicationsWaiting } from './StockLocalIssuanceApplicationsWaiting'

export const StockLocalIssuanceApplicationsDetails = () => {
  const [form] = Form.useForm()

  const { t } = useLocales()

  const { id } = useParams()

  const { setExistingFiles } = useFileHandler({
    form,
    folder: id ? `issuance-${id}` : 'inquiries'
  })

  const { data, isLoading } = useStocksServiceGetInternalInquiryEndpoint(
    {
      id: String(id)
    },
    [String(id)],
    {
      enabled: !!id
    }
  )

  const isSubmitted =
    !!data?.relatedDocuments?.length ||
    data?.state === InternalInventoryDocumentState.REJECTED

  useEffect(() => {
    if (data) {
      const existingFileIds = data?.mediaFiles
        ?.map((file) => file?.id)
        .filter(Boolean) as string[]

      setExistingFiles(existingFileIds)

      const initialFormValues = {
        documentDate: data?.documentDate
          ? dayjs(data?.documentDate)
          : undefined,
        docs: existingFileIds.map((id) => ({
          uid: id,
          name: `File-${id}`,
          status: 'done'
        })),
        inquiryItems: data?.items?.map((item) => ({
          name: `${item?.internationalName?.name} ${item?.internationalName?.dosage}`,
          internationalNameId: item?.internationalName?.id,
          form: {
            name: item?.productForm?.name,
            id: item?.productForm?.id
          },
          quantity: item?.quantity,
          items: item?.roleStocks || []
        }))
      }

      form.setFieldsValue(initialFormValues)
    }
  }, [data])

  if (isLoading) {
    return <LoadingScreen />
  }

  return (
    <PageBreadcrumbs
      title={`${t('stock_applications.liberation_document')}`}
      items={[
        { title: t('menu.consumable_medicaments') },
        { title: t('menu.liberations') },
        {
          title: `${t('stock_applications.liberation_document')}`
        }
      ]}
    >
      <Form form={form} layout="vertical" disabled={isSubmitted}>
        {isSubmitted ? (
          <StockLocalAdminIssuanceApplicationsAcceptedDetails
            data={data}
            form={form}
          />
        ) : (
          <StockLocalIssuanceApplicationsWaiting data={data} form={form} />
        )}
      </Form>
    </PageBreadcrumbs>
  )
}
